import { render } from "./MemberPerki.vue?vue&type=template&id=8823d1d8&scoped=true"
import script from "./MemberPerki.vue?vue&type=script&lang=js"
export * from "./MemberPerki.vue?vue&type=script&lang=js"

import "./MemberPerki.vue?vue&type=style&index=0&id=8823d1d8&scoped=true&lang=css"

import exportComponent from "/Users/mymac/Documents/Digitala/Perki/newest-perki/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8823d1d8"]])

export default __exports__